import React, { useState, useEffect } from 'react';
import Map from './Components/Map';
import Loader from './Components/Loader';
import Header from './Components/Header';
import Select from 'react-select';
let selected = [
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];
const data = [
  {
    value: 0,
    label: 'all',
  },
  {
    value: 1,
    label: 'wildfires',
  },
  {
    value: 2,
    label: 'volcanoes',
  },
  {
    value: 3,
    label: 'severeStorms',
  },
  {
    value: 4,
    label: 'seaLakeIce',
  },
  {
    value: 5,
    label: 'snow',
  },
  {
    value: 6,
    label: 'drought',
  },
  {
    value: 7,
    label: 'dustHaze',
  },
  {
    value: 8,
    label: 'earthquakes',
  },
  {
    value: 9,
    label: 'floods',
  },
  {
    value: 10,
    label: 'tempExtremes',
  },
];
let prev = [];
const customStyles = {
  container: (provided) => ({
    ...provided,
    minWidth: 150,
  }),
  option: (styles, { isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? '#999999' : null,
      color: '#333333',
    };
  },
};
function App() {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState([0]);

  // handle onChange event of the dropdown
  const handleChange = (e) => {
    let temp = [];
    //console.log('prev' + prev);
    let flag = false;
    if (Array.isArray(e)) {
      for (let i = 0; i < e.length; i++) {
        if (e[i].value === 0) {
          flag = true;
          break;
        }
      }
      if (flag && !prev.includes(0)) {
        temp.push(0);
      } else {
        e.map((x) => temp.push(x.value));
        const index = temp.indexOf(0);
        if (index > -1) {
          temp.splice(index, 1);
        }
      }
    }
    setSelectedValue(temp);
    prev = temp;
    //console.log(temp);
    //console.log(selectedValue);
  };
  const filters = () => {
    selected.fill(false, 0);
    if (selectedValue.includes(0)) {
      selected.fill(true, 0);
    } else {
      for (let i = 0; i < selectedValue.length; i++) {
        selected[selectedValue[i]] = true;
      }
    }
  };
  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      const res = await fetch('https://safe-reef-31251.herokuapp.com/https://eonet.sci.gsfc.nasa.gov/api/v3/events');
      const { events } = await res.json();
      setEventData(events);
      setLoading(false);
    };
    fetchEvents();
    //console.log(eventData.length);
  }, []);

  return (
    <div>
      <Header />
      <div className='filter'>
        <Select
          className='dropdown'
          placeholder='Select Events'
          onChange={handleChange}
          value={data.filter((obj) => selectedValue.includes(obj.value))}
          options={data}
          isMulti
          isClearable
          autosize
          styles={customStyles}
        />
        {filters()}
      </div>
      {!loading ? (
        <Map eventData={eventData} selected={selected} />
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default App;
